module.exports = __webpack_public_path__ + "770ca425de0925448c7b21d60431ada9.pdf";